import './Navbar.css'
function Navbar(){
    return (
        
          
          <nav className='body'>
            <div className="logo">
            <a href='#home'>Sana</a>
            </div>
            <div className="links">
            <a href="#home"> Home</a>
            <a href='#about'> About</a>
            <a href='#skills'> Skills</a>
            <a href='#projects'> Projects</a>
            <a href='#contact'>Contact</a>
            </div>
           
          </nav>
       
    )
}
export default Navbar;